import { FlexBox, Body, Radio, FormError } from '@Backlot-Cars/archie';
import { useState } from 'react';

const RadioButtonFormField = ({
	id,
	options,
	defaultValue,
	direction = 'row',
	itemPadding = ['0', 'md', '0', '0'],
	itemAlignment = 'center',
	labelGap = 'xs',
	setValue,
	errors,
	disabled,
	width,
}) => {
	const [selectedValue, setSelectedValue] = useState(defaultValue);

	const handleOnChange = (value) => {
		setSelectedValue(value);
		setValue(id, value, { shouldValidate: true });
	};

	return (
		<FlexBox flexDirection="column" gap="sm" width={width}>
			<FlexBox data-testid={id} flexDirection={direction} flexWrap="wrap" gap="sm">
				{options.map(({ key, value, label }) => (
					<FlexBox key={key} padding={itemPadding} alignItems={itemAlignment} gap={labelGap}>
						<Radio
							id={key}
							value={value}
							checked={value === selectedValue}
							onChange={(value) => handleOnChange(value)}
							disabled={disabled}
						/>
						<Body className="input-label">{label}</Body>
					</FlexBox>
				))}
			</FlexBox>
			{errors[id] && errors[id].message && (
				<FlexBox>
					<FormError data-testid={id + 'Error'}>{errors[id].message}</FormError>
				</FlexBox>
			)}
		</FlexBox>
	);
};

export default RadioButtonFormField;
